export default "__VITE_ASSET__90867568__"